export class QuantityUpdater {
  /**
   * @param {HTMLFormElement} form the quantity selector form
   * @param {HTMLFormElement} linkedCartForm the add-to-cart form whose quantity input must stay in sync
   */
  constructor(form, linkedCartForm) {
    this.form = form;
    this.srcInputQuantity = form.querySelector('.js-control');
    this.linkedCartForm = linkedCartForm;

    // watch change on quantity input
    this.form.addEventListener('THUMBNAIL_USER_QUANTITY_UPDATED', () => {
      this.updateFormQuantity();
    });
  }

  /**
   * updateCapacity : update the capacity when quantity change
   */
  updateFormQuantity() {
    try {
      this.dstInputQuantity = this.linkedCartForm ? this.linkedCartForm.querySelector('input[name=quantity]') : null;
      if (!this.dstInputQuantity) {
        return;
      }
      this.dstInputQuantity.value = this.srcInputQuantity.value;
    } catch (error) {
      console.error('Error on updateQuantity', error);
    }
  }
}